import Vue from 'vue'
import { FilterOption as IFilterOption } from 'services/api-service'
import reviewsStore from 'store/reviews-store'
import ReviewsListToolbar from './reviews-list-toolbar'

import withRender from './reviews-list-utilities.html'
import './reviews-list-utilities.scss'

export default withRender(Vue.extend({
  data() {
    return {
      showSearchField: false,
      filterStore: reviewsStore.filterStore
    }
  },
  props: { showToolbar: Boolean },
  components: { 'tt-reviews-list-toolbar': ReviewsListToolbar },
  computed: {
    appliedFilterOptions() {
      return this.filterStore.filtersFlattened.map((fFilter) => {
        return {
          group: fFilter.group,
          filterName: fFilter.filterName,
          option: fFilter.option,
          optionTitle: fFilter.option.longTitle || fFilter.option.title
        }
      })
    }
  },
  methods: {
    clearAllFilters() {
      this.filterStore.clearFilters()
    },
    removeFilter(group: string, filterName: string, filterOption: IFilterOption) {
      this.filterStore.removeFilterOption(group, filterName, filterOption)
    },
    toggleSearchField(value) {
      this.showSearchField = value
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/reviews-list/reviews-list-utilities.ts